import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { initialOfferPageRooms } from 'contexts/OfferPage/offerPageStateReducer'
import { createSelector } from 'reselect'
import { getIsMultiRoomEnabled } from '../featuresSelectors'
import { isLEHotel } from 'lib/offer/offerTypes'

/**
 * Returns whether multiple room booking is active or not.
 * This includes the related feature flags and other variables that go into it
 */
export const isMultipleRoomBookingActive = createSelector(
  (state: OfferPageState) => state.rooms ?? initialOfferPageRooms,
  (state: OfferPageState, appState: App.State) => !state.bundleOffer && (isLEHotel(state.offer) || !!state.bedbankOffer) && getIsMultiRoomEnabled(appState, state.offer ?? state.bedbankOffer),
  (state: OfferPageState) => state.multiRoomMode,
  (rooms, isMultiRoomEnabled, multiRoomMode) => {
    return isMultiRoomEnabled && rooms.length > 1 && multiRoomMode === 'individual'
  },
)
